export default {
  qrcode: {
    BackMessage: '回复消息',
    ShowQRCode: '查看二维码',
    ChooseWeChatName: '选择微信名称',
    NickName: '昵称',
    RefereeCode: '加权码',
    RefereeName: '加权名称',
    Country: '国家',
    Province: '省份',
    City: '城市',
    Language: '语言',
    HeadImgUrl: '用户头像地址',
    IsSubscribe: '是否关注',
    SubscribeTime: '关注时间',
    Keyword: '关键字',
    SortNo: '排序号',
    LabelName: '标签名称',
    ClientNum: '客户数量',
    MessageType: '消息类型'
  }

}



// WEBPACK FOOTER //
// ./src/i18n/lang/cn/wechat/qrcode.js